import React from "react";
import {Skeleton, Table, TableCell, TableHeading} from "@nike/eds";
import {RequestSearchResultItem} from "./RequestSearchResultItem";

function RequestSearchResults({ loading, searchResults }) {

    const headers = [
        {Header: "Event timestamp"},
        {Header: "Transaction ID"},
        {Header: "Event Name"},
        {Header: "Status"},
        {Header: "Business reference"},
        {Header: "Duration"},
        {Header: "Payload"},
        {Header: "Details"}
    ];

    return (
         <div className="eds-grid eds-grid--m-cols-6 eds-elevation--4">
            <Table className="eds-grid--m-col-6 eds-grid--item-align-start">
                <thead>
                <tr>
                    {headers.map(column => (<TableHeading key={column.Header}>{column.Header}</TableHeading>))}
                </tr>
                </thead>
                <tbody>
                { loading &&
                    <>
                        <tr>
                            <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                            <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                            <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                            <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                            <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                            <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                            <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                        </tr>
                    </>
                }
                {!loading && searchResults.map(searchResult => (
                    <RequestSearchResultItem key={searchResult.traceId} searchResult={searchResult} />
                ))}
                </tbody>
            </Table>
        </div>
    );
}

export {RequestSearchResults};
